export const ToolsRoutes = {
  DIAGNOSTIC_RESULT: {
    path: 'diagnostic-result',
    name: 'diagnostic-result'
  },
  DIAGNOSTIC_TOOL: {
    path: 'tools/diagnostic-tool',
    name: 'diagnostic-tool'
  }
};
